/**
 *
 */
 window.addEventListener('load', function() {

  var backlink = document.querySelector('.js-backlink');

  if ( ! backlink )
    return;

  backlink.href = document.referrer;

});
